import { render, staticRenderFns } from "./ProblemView.html?vue&type=template&id=3a139f24&scoped=true&external"
import script from "./ProblemView.ts?vue&type=script&lang=ts&external"
export * from "./ProblemView.ts?vue&type=script&lang=ts&external"
import style0 from "./ProblemView.scss?vue&type=style&index=0&id=3a139f24&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a139f24",
  null
  
)

export default component.exports